import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LeilaoPesquisaComponent } from "./pesquisa/leilao-pesquisa.component";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { LeilaoLoteComponent } from "./leilao-lote/leilao-lote.component";
import { ConsultaStatusLeilaoComponent } from "./consulta-status-leilao/consulta-status-leilao.component";
import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";
import { DominiosResolver } from "src/app/shared/resolvers/dominios.resolver";
import { DetalheLeilaoComponent } from "./detalhe-leilao/detalhe-leilao.component";

const routes: Routes = [
  {
    path: "leilao",
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver,
    },
    children: [
      {
        path: "",
        redirectTo: "pesquisa",
        pathMatch: "full",
      },
      {
        path: "pesquisa",
        pathMatch: "full",
        component: LeilaoPesquisaComponent,
      },
      {
        path: "cadastro/lote",
        pathMatch: "full",
        component: LeilaoLoteComponent,
      },
      {
        path: "leiloes",
        pathMatch: "full",
        component: ConsultaStatusLeilaoComponent,
      },
      {
        path: "detalhe/:id",
        component: DetalheLeilaoComponent,
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LeilaoRoutingModule {}
